/**
 * Current Context Composable
 * Phase 6.2: Replacement for DEMO_SUPPLIER_ID and DEMO_ADVISOR_ID
 *
 * Provides the current user's supplier/advisor IDs from the user store.
 * Use "me" as a fallback for endpoints that support /me resolution on backend.
 */
import { computed } from 'vue'
import { useUserStore } from '../stores/user'

export function useCurrentContext() {
    const userStore = useUserStore()

    /**
     * Current advisor ID from authenticated user.
     * Returns 'me' as fallback for endpoints that support backend resolution.
     */
    const advisorId = computed(() => userStore.advisorId || 'me')

    /**
     * Current supplier ID from authenticated user.
     * Returns null if user is not a supplier - caller should handle this.
     */
    const supplierId = computed(() => userStore.supplierId)

    /**
     * Whether the current user has a valid advisor context
     */
    const hasAdvisorContext = computed(() => !!userStore.advisorId || userStore.isAdvisor)

    /**
     * Whether the current user has a valid supplier context
     */
    const hasSupplierContext = computed(() => !!userStore.supplierId || userStore.isSupplier)

    return {
        advisorId,
        supplierId,
        hasAdvisorContext,
        hasSupplierContext,
        // Also expose store for direct access
        userStore
    }
}
